import CloseIcon from "@mui/icons-material/Close";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  styled,
} from "@mui/material";
import { ModalProps } from "./types";

const Modal = ({
  children,
  open,
  title,
  onClose,
  maxWidth,
  width,
  className,
  PaperProps,
  isFullScreenToggle,
  closeButtonClassName,
}: ModalProps) => {
  return (
    <StyledDialog
      style={{ overflow: "hidden" }}
      open={open}
      onClose={onClose}
      maxWidth={maxWidth ?? false}
      className={className}
      PaperProps={{
        className: "modal-paper",
        style: {
          width,
        },
        ...PaperProps,
      }}
    >
      {title && <StyledDialogTitle>{title}</StyledDialogTitle>}
      {onClose ? (
        <StyledIconButton
          aria-label={isFullScreenToggle ? "exit fullscreen" : "close"}
          onClick={(event) => onClose(event, "backdropClick")}
          className={`modal-close-button ${closeButtonClassName || ""}`}
        >
          {isFullScreenToggle ? <CloseFullscreenIcon /> : <CloseIcon />}
        </StyledIconButton>
      ) : null}
      <StyledDialogContent>{children}</StyledDialogContent>
    </StyledDialog>
  );
};

export default Modal;
const StyledIconButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  right: "1rem",
  top: "1rem",
  padding: "0.5rem",
  zIndex: 1,
  svg: {
    fill: theme.tokens.colors.gray[6],
  },
}));

const StyledDialogTitle = styled(DialogTitle)(() => ({
  fontFamily: "'Nunito',sans-serif",
  padding: 0,
  paddingBottom: "1rem",
}));

const StyledDialogContent = styled(DialogContent)(() => ({
  padding: "0",
}));
const StyledDialog = styled(Dialog)(({ theme }) => ({
  ".modal-paper": {
    background:
      theme.shapeTheme === "dark" ? theme.tokens.colors.gray[1] : "#fff",

    borderRadius: "0.5rem",
    padding: "1.5rem",
  },
}));
